import { Box, Card, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { PageHeader } from "components/layout/PageHeader";
import IOSSwitch from "components/forms/fields/IOSSwitch";
import { NotificationSettings, useGetNotificationSettings, useUpdateNotificationSettings } from "core/settings/hooks";

type RowProps = {
  name: string;
  email: string;
  enabled: boolean;
  onToggle: () => void;
};

const NotificationsRow: React.FC<RowProps> = ({ name, email, enabled, onToggle }) => {
  return (
    <TableRow sx={{ td: { fontSize: 15 }}}>
      <TableCell sx={{ width: '50%' }}>{name}</TableCell>
      <TableCell sx={{ fontWeight: 300, color: '#333' }}>{email}</TableCell>
      <TableCell sx={{ width: '20%' }}>
        <IOSSwitch checked={enabled} onClick={onToggle} />
      </TableCell>
    </TableRow>
  );
}

type Notification = {
  title: string;
  description: string;
  setting_field: 'new_candidate' | 'new_application';
}

const notifications: Notification[] = [
  {
    title: 'Nouvelle inscription',
    description: 'Vous recevrez un mail dès qu\'un candidat arrive dans la colonne [NEW] de l\'onglet "Candidats". Si vous ne les recevez pas, vérifiez vos spams.',
    setting_field: 'new_candidate'
  },
  {
    title: "Candidature d'un intérimaire à une mission",
    description: 'Vous recevrez un mail dès qu\'un intérimaire candidate à une nouvelle mission. Si vous ne les recevez pas, vérifiez vos spams.',
    setting_field: 'new_application'
  },
]

export function NotificationsPage() {
  const { data } = useGetNotificationSettings();
  const updateNotificationSettings = useUpdateNotificationSettings();

  return (
    <>
      <PageHeader title="Notifications" subtitle="Choisissez les emails que vous souhaitez recevoir" />

      <Box p={4}>
        <Stack spacing={3}>
          {notifications.map((n) => (
            <Card sx={{ p: 3 }} key={n.setting_field}>
              <Typography fontWeight="500" color="#444" fontSize={18}>
                {n.title}
              </Typography>
              <Typography variant="body2" mt={1} color="#888" fontWeight={300} fontSize={13}>
                {n.description}
              </Typography>
              {data?.agency && (
                <Table sx={{ mt: 3, '.MuiTableCell-root': { px: 0 }}}>
                  <TableBody>
                    <NotificationsRow
                      name="Agence"
                      email={data.agency.email}
                      enabled={data.agency[n.setting_field]}
                      onToggle={() => updateNotificationSettings.mutate({ id: data.agency.id, data: { [n.setting_field]: !data.agency[n.setting_field] } })}
                    />
                  </TableBody>
                </Table>
              )}
              <Table sx={{ mt: 3, '.MuiTableCell-root': { borderColor: '#ccc', px: 0 }}}>
                <TableHead>
                  <TableRow sx={{ th: { color: '#777', fontWeight: 300, fontSize: 15, px: 0, py: 1 }}}>
                    <TableCell>Agent</TableCell>
                    <TableCell>Mail</TableCell>
                    <TableCell>Actif</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.agents.map((a: NotificationSettings) => (
                    <NotificationsRow
                      key={a.id}
                      name={a.name}
                      email={a.email}
                      enabled={a[n.setting_field]}
                      onToggle={() => updateNotificationSettings.mutate({ id: a.id, data: { [n.setting_field]: !a[n.setting_field] } })}
                    />
                  ))}
                </TableBody>
              </Table>
            </Card>
          ))}
        </Stack>
      </Box>
    </>
  );
};
